import { useContext } from 'react'

import { TeamsContext } from './TeamsProvider.tsx'

export type { Team } from './TeamsProvider.tsx'

export const useTeams = () => useContext(TeamsContext)
